webpackJsonp([35783957827783],{

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _swipeJsIso = __webpack_require__(1049);
	
	var _swipeJsIso2 = _interopRequireDefault(_swipeJsIso);
	
	var _objectAssign = __webpack_require__(14);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactSwipe = function (_Component) {
	  _inherits(ReactSwipe, _Component);
	
	  function ReactSwipe() {
	    _classCallCheck(this, ReactSwipe);
	
	    return _possibleConstructorReturn(this, (ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).apply(this, arguments));
	  }
	
	  _createClass(ReactSwipe, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var swipeOptions = this.props.swipeOptions;
	
	
	      this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          childCount = _props.childCount,
	          swipeOptions = _props.swipeOptions;
	
	
	      if (prevProps.childCount !== childCount) {
	        this.swipe.kill();
	        this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.swipe.kill();
	      this.swipe = void 0;
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.swipe.next();
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      this.swipe.prev();
	    }
	  }, {
	    key: 'slide',
	    value: function slide() {
	      var _swipe;
	
	      (_swipe = this.swipe).slide.apply(_swipe, arguments);
	    }
	  }, {
	    key: 'getPos',
	    value: function getPos() {
	      return this.swipe.getPos();
	    }
	  }, {
	    key: 'getNumSlides',
	    value: function getNumSlides() {
	      return this.swipe.getNumSlides();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          style = _props2.style,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(container) {
	            return _this2.container = container;
	          }, id: id, className: 'react-swipe-container ' + className, style: style.container },
	        _react2.default.createElement(
	          'div',
	          { style: style.wrapper },
	          _react2.default.Children.map(children, function (child) {
	            if (!child) {
	              return null;
	            }
	
	            var childStyle = child.props.style ? (0, _objectAssign2.default)({}, style.child, child.props.style) : style.child;
	
	            return _react2.default.cloneElement(child, { style: childStyle });
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReactSwipe;
	}(_react.Component);
	
	ReactSwipe.propTypes = {
	  swipeOptions: _propTypes2.default.shape({
	    startSlide: _propTypes2.default.number,
	    speed: _propTypes2.default.number,
	    auto: _propTypes2.default.number,
	    continuous: _propTypes2.default.bool,
	    disableScroll: _propTypes2.default.bool,
	    stopPropagation: _propTypes2.default.bool,
	    swiping: _propTypes2.default.func,
	    callback: _propTypes2.default.func,
	    transitionEnd: _propTypes2.default.func
	  }),
	  style: _propTypes2.default.shape({
	    container: _propTypes2.default.object,
	    wrapper: _propTypes2.default.object,
	    child: _propTypes2.default.object
	  }),
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  childCount: _propTypes2.default.number
	};
	ReactSwipe.defaultProps = {
	  swipeOptions: {},
	  style: {
	    container: {
	      overflow: 'hidden',
	      visibility: 'hidden',
	      position: 'relative'
	    },
	
	    wrapper: {
	      overflow: 'hidden',
	      position: 'relative'
	    },
	
	    child: {
	      float: 'left',
	      width: '100%',
	      position: 'relative',
	      transitionProperty: 'transform'
	    }
	  },
	  className: '',
	  childCount: 0
	};
	exports.default = ReactSwipe;
	module.exports = exports['default'];


/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	/*
	 * Swipe 2.0.0
	 * Brad Birdsall
	 * https://github.com/thebird/Swipe
	 * Copyright 2013-2015, MIT License
	 *
	*/
	
	(function (root, factory) {
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = factory();
	    } else {
	        root.Swipe = factory();
	    }
	}(this, function () {
	  'use strict';
	
	  return function Swipe (container, options) {
	    // utilities
	    var noop = function() {}; // simple no operation function
	    var offloadFn = function(fn) { setTimeout(fn || noop, 0); }; // offload a functions execution
	
	    // check browser capabilities
	    var browser = {
	      addEventListener: !!window.addEventListener,
	      touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch,
	      transitions: (function(temp) {
	        var props = ['transitionProperty', 'WebkitTransition', 'MozTransition', 'OTransition', 'msTransition'];
	        for ( var i in props ) if (temp.style[ props[i] ] !== undefined) return true;
	        return false;
	      })(document.createElement('swipe'))
	    };
	
	    // quit if no root element
	    if (!container) return;
	    var element = container.children[0];
	    var slides, slidePos, width, length;
	    options = options || {};
	    var index = parseInt(options.startSlide, 10) || 0;
	    var speed = options.speed || 300;
	    var continuous = options.continuous = options.continuous !== undefined ? options.continuous : true;
	
	    function setup() {
	
	      // cache slides
	      slides = element.children;
	      length = slides.length;
	
	      // set continuous to false if only one slide
	      continuous = slides.length < 2 ? false : options.continuous;
	
	      //special case if two slides
	      if (browser.transitions && continuous && slides.length < 3) {
	        element.appendChild(slides[0].cloneNode(true));
	        element.appendChild(element.children[1].cloneNode(true));
	        slides = element.children;
	      }
	
	      // create an array to store current positions of each slide
	      slidePos = new Array(slides.length);
	
	      // determine width of each slide
	      width = Math.round(container.getBoundingClientRect().width || container.offsetWidth);
	
	      element.style.width = (slides.length * width) + 'px';
	
	      // stack elements
	      var pos = slides.length;
	      while(pos--) {
	
	        var slide = slides[pos];
	
	        slide.style.width = width + 'px';
	        slide.setAttribute('data-index', pos);
	
	        if (browser.transitions) {
	          slide.style.left = (pos * -width) + 'px';
	          move(pos, index > pos ? -width : (index < pos ? width : 0), 0);
	        }
	
	      }
	
	      // reposition elements before and after index
	      if (continuous && browser.transitions) {
	        move(circle(index-1), -width, 0);
	        move(circle(index+1), width, 0);
	      }
	
	      if (!browser.transitions) element.style.left = (index * -width) + 'px';
	
	      container.style.visibility = 'visible';
	
	    }
	
	    function prev() {
	
	      if (continuous) slide(index-1);
	      else if (index) slide(index-1);
	
	    }
	
	    function next() {
	
	      if (continuous) slide(index+1);
	      else if (index < slides.length - 1) slide(index+1);
	
	    }
	
	    function circle(index) {
	
	      // a simple positive modulo using slides.length
	      return (slides.length + (index % slides.length)) % slides.length;
	
	    }
	
	    function slide(to, slideSpeed) {
	
	      // do nothing if already on requested slide
	      if (index == to) return;
	
	      if (browser.transitions) {
	
	        var direction = Math.abs(index-to) / (index-to); // 1: backward, -1: forward
	
	        // get the actual position of the slide
	        if (continuous) {
	          var natural_direction = direction;
	          direction = -slidePos[circle(to)] / width;
	
	          // if going forward but to < index, use to = slides.length + to
	          // if going backward but to > index, use to = -slides.length + to
	          if (direction !== natural_direction) to =  -direction * slides.length + to;
	
	        }
	
	        var diff = Math.abs(index-to) - 1;
	
	        // move all the slides between index and to in the right direction
	        while (diff--) move( circle((to > index ? to : index) - diff - 1), width * direction, 0);
	
	        to = circle(to);
	
	        move(index, width * direction, slideSpeed || speed);
	        move(to, 0, slideSpeed || speed);
	
	        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
	
	      } else {
	
	        to = circle(to);
	        animate(index * -width, to * -width, slideSpeed || speed);
	        //no fallback for a circular continuous if the browser does not accept transitions
	      }
	
	      index = to;
	      offloadFn(options.callback && options.callback(index, slides[index]));
	    }
	
	    function move(index, dist, speed) {
	
	      translate(index, dist, speed);
	      slidePos[index] = dist;
	
	    }
	
	    function translate(index, dist, speed) {
	
	      var slide = slides[index];
	      var style = slide && slide.style;
	
	      if (!style) return;
	
	      style.webkitTransitionDuration =
	      style.MozTransitionDuration =
	      style.msTransitionDuration =
	      style.OTransitionDuration =
	      style.transitionDuration = speed + 'ms';
	
	      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
	      style.msTransform =
	      style.MozTransform =
	      style.OTransform = 'translateX(' + dist + 'px)';
	
	    }
	
	    function animate(from, to, speed) {
	
	      // if not an animation, just reposition
	      if (!speed) {
	
	        element.style.left = to + 'px';
	        return;
	
	      }
	
	      var start = +new Date();
	
	      var timer = setInterval(function() {
	
	        var timeElap = +new Date() - start;
	
	        if (timeElap > speed) {
	
	          element.style.left = to + 'px';
	
	          if (delay) begin();
	
	          options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
	
	          clearInterval(timer);
	          return;
	
	        }
	
	        element.style.left = (( (to - from) * (Math.floor((timeElap / speed) * 100) / 100) ) + from) + 'px';
	
	      }, 4);
	
	    }
	
	    // setup auto slideshow
	    var delay = options.auto || 0;
	    var interval;
	
	    function begin() {
	      clearTimeout(interval);
	      interval = setTimeout(next, delay);
	
	    }
	
	    function stop() {
	
	      delay = 0;
	      clearTimeout(interval);
	
	    }
	
	
	    // setup initial vars
	    var start = {};
	    var delta = {};
	    var isScrolling;
	
	    // setup event capturing
	    var events = {
	
	      handleEvent: function(event) {
	
	        switch (event.type) {
	          case 'touchstart': this.start(event); break;
	          case 'touchmove': this.move(event); break;
	          case 'touchend': offloadFn(this.end(event)); break;
	          case 'webkitTransitionEnd':
	          case 'msTransitionEnd':
	          case 'oTransitionEnd':
	          case 'otransitionend':
	          case 'transitionend': offloadFn(this.transitionEnd(event)); break;
	          case 'resize': offloadFn(setup); break;
	        }
	
	        if (options.stopPropagation) event.stopPropagation();
	
	      },
	      start: function(event) {
	
	        var touches = event.touches[0];
	
	        // measure start values
	        start = {
	
	          // get initial touch coords
	          x: touches.pageX,
	          y: touches.pageY,
	
	          // store time to determine touch duration
	          time: +new Date()
	
	        };
	
	        // used for testing first move event
	        isScrolling = undefined;
	
	        // reset delta and end measurements
	        delta = {};
	
	        // attach touchmove and touchend listeners
	        element.addEventListener('touchmove', this, false);
	        element.addEventListener('touchend', this, false);
	
	      },
	      move: function(event) {
	
	        // ensure swiping with one touch and not pinching
	        if ( event.touches.length > 1 || event.scale && event.scale !== 1) return;
	
	        if (options.disableScroll) return;
	
	        var touches = event.touches[0];
	
	        // measure change in x and y
	        delta = {
	          x: touches.pageX - start.x,
	          y: touches.pageY - start.y
	        };
	
	        // determine if scrolling test has run - one time test
	        if ( typeof isScrolling == 'undefined') {
	          isScrolling = !!( isScrolling || Math.abs(delta.x) < Math.abs(delta.y) );
	        }
	
	        // if user is not trying to scroll vertically
	        if (!isScrolling) {
	
	          // prevent native scrolling
	          event.preventDefault();
	
	          // stop slideshow
	          stop();
	
	          // increase resistance if first or last slide
	          if (continuous) { // we don't add resistance at the end
	
	            translate(circle(index-1), delta.x + slidePos[circle(index-1)], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(circle(index+1), delta.x + slidePos[circle(index+1)], 0);
	
	          } else {
	
	            delta.x =
	              delta.x /
	                ( (!index && delta.x > 0 ||         // if first slide and sliding left
	                  index == slides.length - 1 &&     // or if last slide and sliding right
	                  delta.x < 0                       // and if sliding at all
	                ) ?
	                ( Math.abs(delta.x) / width + 1 )      // determine resistance level
	                : 1 );                                 // no resistance if false
	
	            // translate 1:1
	            translate(index-1, delta.x + slidePos[index-1], 0);
	            translate(index, delta.x + slidePos[index], 0);
	            translate(index+1, delta.x + slidePos[index+1], 0);
	          }
	          options.swiping && options.swiping(-delta.x / width);
	
	        }
	
	      },
	      end: function(event) {
	
	        // measure duration
	        var duration = +new Date() - start.time;
	
	        // determine if slide attempt triggers next/prev slide
	        var isValidSlide =
	              Number(duration) < 250 &&         // if slide duration is less than 250ms
	              Math.abs(delta.x) > 20 ||         // and if slide amt is greater than 20px
	              Math.abs(delta.x) > width/2;      // or if slide amt is greater than half the width
	
	        // determine if slide attempt is past start and end
	        var isPastBounds =
	              !index && delta.x > 0 ||                      // if first slide and slide amt is greater than 0
	              index == slides.length - 1 && delta.x < 0;    // or if last slide and slide amt is less than 0
	
	        if (continuous) isPastBounds = false;
	
	        // determine direction of swipe (true:right, false:left)
	        var direction = delta.x < 0;
	
	        // if not scrolling vertically
	        if (!isScrolling) {
	
	          if (isValidSlide && !isPastBounds) {
	
	            if (direction) {
	
	              if (continuous) { // we need to get the next in this direction in place
	
	                move(circle(index-1), -width, 0);
	                move(circle(index+2), width, 0);
	
	              } else {
	                move(index-1, -width, 0);
	              }
	
	              move(index, slidePos[index]-width, speed);
	              move(circle(index+1), slidePos[circle(index+1)]-width, speed);
	              index = circle(index+1);
	
	            } else {
	              if (continuous) { // we need to get the next in this direction in place
	
	                move(circle(index+1), width, 0);
	                move(circle(index-2), -width, 0);
	
	              } else {
	                move(index+1, width, 0);
	              }
	
	              move(index, slidePos[index]+width, speed);
	              move(circle(index-1), slidePos[circle(index-1)]+width, speed);
	              index = circle(index-1);
	
	            }
	
	            options.callback && options.callback(index, slides[index]);
	
	          } else {
	
	            if (continuous) {
	
	              move(circle(index-1), -width, speed);
	              move(index, 0, speed);
	              move(circle(index+1), width, speed);
	
	            } else {
	
	              move(index-1, -width, speed);
	              move(index, 0, speed);
	              move(index+1, width, speed);
	            }
	
	          }
	
	        }
	
	        // kill touchmove and touchend event listeners until touchstart called again
	        element.removeEventListener('touchmove', events, false);
	        element.removeEventListener('touchend', events, false);
	        element.removeEventListener('touchforcechange', function() {}, false);
	
	      },
	      transitionEnd: function(event) {
	
	        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
	
	          if (delay) begin();
	
	          options.transitionEnd && options.transitionEnd.call(event, index, slides[index]);
	
	        }
	
	      }
	
	    };
	
	    // trigger setup
	    setup();
	
	    // start auto slideshow if applicable
	    if (delay) begin();
	
	
	    // add event listeners
	    if (browser.addEventListener) {
	
	      // set touchstart event on element
	      if (browser.touch) {
	        element.addEventListener('touchstart', events, false);
	        element.addEventListener('touchforcechange', function() {}, false);
	      }
	
	      if (browser.transitions) {
	        element.addEventListener('webkitTransitionEnd', events, false);
	        element.addEventListener('msTransitionEnd', events, false);
	        element.addEventListener('oTransitionEnd', events, false);
	        element.addEventListener('otransitionend', events, false);
	        element.addEventListener('transitionend', events, false);
	      }
	
	      // set resize event on window
	      window.addEventListener('resize', events, false);
	
	    } else {
	
	      window.onresize = function () { setup(); }; // to play nice with old IE
	
	    }
	
	    // expose the Swipe API
	    return {
	      setup: function() {
	
	        setup();
	
	      },
	      slide: function(to, speed) {
	
	        // cancel slideshow
	        stop();
	
	        slide(to, speed);
	
	      },
	      prev: function() {
	
	        // cancel slideshow
	        stop();
	
	        prev();
	
	      },
	      next: function() {
	
	        // cancel slideshow
	        stop();
	
	        next();
	
	      },
	      stop: function() {
	
	        // cancel slideshow
	        stop();
	
	      },
	      getPos: function() {
	
	        // return current index position
	        return index;
	
	      },
	      getNumSlides: function() {
	
	        // return total number of slides
	        return length;
	      },
	      kill: function() {
	
	        // cancel slideshow
	        stop();
	
	        // reset element
	        element.style.width = '';
	        element.style.left = '';
	
	        // reset slides
	        var pos = slides.length;
	        while(pos--) {
	
	          var slide = slides[pos];
	          slide.style.width = '';
	          slide.style.left = '';
	
	          if (browser.transitions) translate(pos, 0, 0);
	        }
	
	        // removed event listeners
	        if (browser.addEventListener) {
	
	          // remove current event listeners
	          element.removeEventListener('touchstart', events, false);
	          element.removeEventListener('webkitTransitionEnd', events, false);
	          element.removeEventListener('msTransitionEnd', events, false);
	          element.removeEventListener('oTransitionEnd', events, false);
	          element.removeEventListener('otransitionend', events, false);
	          element.removeEventListener('transitionend', events, false);
	          window.removeEventListener('resize', events, false);
	
	        } else {
	          window.onresize = null;
	        }
	      }
	    };
	  };
	}));


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: #fbf9ec;\n  position: relative;\n'], ['\n  background-color: #fbf9ec;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  background-color: #fbf9ec;\n  width: 100%;\n  padding: 3rem;\n  position: relative;\n\n  ', '\n\n  // prettier-ignore\n  ', '\n'], ['\n  display: flex;\n  background-color: #fbf9ec;\n  width: 100%;\n  padding: 3rem;\n  position: relative;\n\n  ', '\n\n  // prettier-ignore\n  ', '\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    padding: 3rem 0;\n  '], ['\n    padding: 3rem 0;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    flex-direction: column;\n    padding: 3rem 15px;\n  '], ['\n    flex-direction: column;\n    padding: 3rem 15px;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 2rem;\n  width: 25%;\n\n  img {\n    height: 60px;\n  }\n\n  p, h3 {\n    width: 100%;\n  }\n\n  h3 {\n    text-align: center;\n  }\n\n  ', ';\n\n  ', ';\n\n  &:nth-child(even) {\n    border-left: 1px solid rgba(0, 0, 0, 0.1);\n    border-right: 1px solid rgba(0, 0, 0, 0.1);\n\n    // prettier-ignore\n    ', '\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 2rem;\n  width: 25%;\n\n  img {\n    height: 60px;\n  }\n\n  p, h3 {\n    width: 100%;\n  }\n\n  h3 {\n    text-align: center;\n  }\n\n  ', ';\n\n  ', ';\n\n  &:nth-child(even) {\n    border-left: 1px solid rgba(0, 0, 0, 0.1);\n    border-right: 1px solid rgba(0, 0, 0, 0.1);\n\n    // prettier-ignore\n    ', '\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 33%;\n  '], ['\n    width: 33%;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n    padding: 2rem 0;\n    text-align: center;\n  '], ['\n    width: 100%;\n    padding: 2rem 0;\n    text-align: center;\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n      border-left: 0;\n      border-right: 0;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n      border-top: 1px solid rgba(0, 0, 0, 0.1);\n    '], ['\n      border-left: 0;\n      border-right: 0;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n      border-top: 1px solid rgba(0, 0, 0, 0.1);\n    ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: -50px;\n  right: 10%;\n  width: 20%;\n  z-index: 20;\n  max-width: 270px;\n\n  // prettier-ignore\n  ', '\n\n  img {\n    object-fit: contain;\n    font-family: \'object-fit: contain;\';\n    margin: 0;\n  }\n'], ['\n  position: absolute;\n  top: -50px;\n  right: 10%;\n  width: 20%;\n  z-index: 20;\n  max-width: 270px;\n\n  // prettier-ignore\n  ', '\n\n  img {\n    object-fit: contain;\n    font-family: \'object-fit: contain;\';\n    margin: 0;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(35);
	
	var _theme = __webpack_require__(9);
	
	var _POTMBubbleUSA = __webpack_require__(397);
	
	var _POTMBubbleUSA2 = _interopRequireDefault(_POTMBubbleUSA);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IconBlurbWrapper = _styledComponents2.default.section(_templateObject);
	
	var IconBlurbContainer = _Container.Container.extend(_templateObject2, _theme.media.forSmallMediumOnly(_templateObject3), _theme.media.forSmallOnly(_templateObject4));
	
	var Blurb = _styledComponents2.default.div(_templateObject5, _theme.media.forSmallMediumOnly(_templateObject6), _theme.media.forSmallOnly(_templateObject7), _theme.media.forSmallOnly(_templateObject8));
	
	var BadgeImage = _styledComponents2.default.div(_templateObject9, _theme.media.forSmallMediumOnly(_templateObject10));
	
	var IconBlurbRow = function IconBlurbRow(_ref) {
	  var blurbs = _ref.blurbs;
	
	  return _react2.default.createElement(
	    IconBlurbWrapper,
	    null,
	    _react2.default.createElement(
	      IconBlurbContainer,
	      null,
	      blurbs.map(function (item) {
	        return _react2.default.createElement(
	          Blurb,
	          { key: item.header },
	          _react2.default.createElement('img', { src: item.icon_image, alt: item.text }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            item.header
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.text
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      BadgeImage,
	      null,
	      _react2.default.createElement('img', { src: _POTMBubbleUSA2.default, alt: 'Fresh from the Vine and Hand Picked Badge' })
	    )
	  );
	};
	
	exports.default = IconBlurbRow;
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n  position: relative;\n  margin: 4rem auto;\n\n  ', ';\n\n  &.nutritionStyle {\n    margin-top: calc(85px + 4rem);\n\n    @media (min-width: 768px) {\n      /* max-width: 720px; */\n      margin-top: 4rem;\n      height: 460px;\n    }\n\n    @media (min-width: 992px) {\n      height: 500px;\n    }\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n  position: relative;\n  margin: 4rem auto;\n\n  ', ';\n\n  &.nutritionStyle {\n    margin-top: calc(85px + 4rem);\n\n    @media (min-width: 768px) {\n      /* max-width: 720px; */\n      margin-top: 4rem;\n      height: 460px;\n    }\n\n    @media (min-width: 992px) {\n      height: 500px;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin: 4rem 15px;\n    width: calc(100% - 30px);\n  '], ['\n    margin: 4rem 15px;\n    width: calc(100% - 30px);\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 100%;\n'], ['\n  width: 100%;\n  height: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  padding: 3rem;\n  background-color: white;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  &.nutritionStyle {\n    display: flex;\n    align-items: center;\n\n    ', ';\n  }\n'], ['\n  text-align: center;\n  padding: 3rem;\n  background-color: white;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  &.nutritionStyle {\n    display: flex;\n    align-items: center;\n\n    ', ';\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n      padding: 3rem 1rem 1rem;\n    '], ['\n      padding: 3rem 1rem 1rem;\n    ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(35);
	
	var _theme = __webpack_require__(9);
	
	var _gatsbyImage = __webpack_require__(86);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TidyInfoBoxWrapper = _Container.Container.extend(_templateObject, _theme.media.forSmallOnly(_templateObject2));
	
	var ImageWrapper = _styledComponents2.default.div(_templateObject3);
	
	var ImageBorderInfoBoxContainer = _Container.Container.extend(_templateObject4, _theme.media.forSmallOnly(_templateObject5));
	
	var ImageBorderInfoBox = function ImageBorderInfoBox(_ref) {
	  var borderImage = _ref.borderImage,
	      children = _ref.children,
	      style = _ref.style,
	      nutritionStyle = _ref.nutritionStyle;
	
	  return _react2.default.createElement(
	    TidyInfoBoxWrapper,
	    {
	      style: style,
	      className: '' + (nutritionStyle ? 'nutritionStyle' : '')
	    },
	    _react2.default.createElement(
	      ImageWrapper,
	      null,
	      _react2.default.createElement(_gatsbyImage2.default, {
	        sizes: borderImage.sizes,
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%'
	        }
	      }),
	      _react2.default.createElement(
	        ImageBorderInfoBoxContainer,
	        {
	          className: '' + (nutritionStyle ? 'nutritionStyle' : '')
	        },
	        children
	      )
	    )
	  );
	};
	
	exports.default = ImageBorderInfoBox;
	module.exports = exports['default'];

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin-top: 2rem;\n  height: 850px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: relative;\n  margin-top: 2rem;\n  height: 850px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  z-index: 10;\n  text-align: center;\n  margin-top: 40px;\n\n  ', ';\n'], ['\n  position: relative;\n  z-index: 10;\n  text-align: center;\n  margin-top: 40px;\n\n  ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    margin-top: 70px;\n  '], ['\n    margin-top: 70px;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  width: 100%;\n'], ['\n  display: flex;\n  justify-content: center;\n  width: 100%;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  display: block;\n  width: 33%;\n  border-radius: 6px;\n  overflow: hidden;\n  text-align: left;\n  margin: 0 1rem;\n\n  ', ';\n'], ['\n  background-color: white;\n  display: block;\n  width: 33%;\n  border-radius: 6px;\n  overflow: hidden;\n  text-align: left;\n  margin: 0 1rem;\n\n  ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n\n    &:not(:first-child) {\n      display: none;\n    }\n  '], ['\n    width: 100%;\n\n    &:not(:first-child) {\n      display: none;\n    }\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  font-family: Montserrat;\n  font-size: 24px;\n  max-width: 70%;\n  margin: 0 auto 5rem;\n  color: ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  font-family: Montserrat;\n  font-size: 24px;\n  max-width: 70%;\n  margin: 0 auto 5rem;\n  color: ', ';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    font-size: 21px;\n    margin-bottom: 3rem;\n  '], ['\n    font-size: 21px;\n    margin-bottom: 3rem;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    font-size: 18px;\n  '], ['\n    font-size: 18px;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 0;\n'], ['\n  margin-bottom: 0;\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 0.75rem;\n'], ['\n  margin-bottom: 0.75rem;\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  padding: 1rem;\n'], ['\n  padding: 1rem;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(35);
	
	var _theme = __webpack_require__(9);
	
	var _gatsbyImage = __webpack_require__(86);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _H = __webpack_require__(91);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _PostTagDateRow = __webpack_require__(109);
	
	var _PostTagDateRow2 = _interopRequireDefault(_PostTagDateRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PostCollectionWrapper = _styledComponents2.default.section(_templateObject);
	
	var PostCollectionContainer = _styledComponents2.default.div(_templateObject2, _theme.media.forSmallOnly(_templateObject3));
	
	var PostBlurbContainer = _Container.Container.extend(_templateObject4);
	
	var PostBlurb = _styledComponents2.default.a(_templateObject5, _theme.media.forSmallOnly(_templateObject6));
	
	var PostCollectionInfo = _styledComponents2.default.p(_templateObject7, function (props) {
	  return props.theme.defaultHeaderColor;
	}, _theme.media.forSmallMediumOnly(_templateObject8), _theme.media.forSmallOnly(_templateObject9));
	
	var PostImage = _styledComponents2.default.img(_templateObject10);
	var PostHeading = _styledComponents2.default.h3(_templateObject11);
	var PostTextSection = _styledComponents2.default.div(_templateObject12);
	
	var PostCollection = function PostCollection(_ref) {
	  var backgroundImage = _ref.backgroundImage,
	      posts = _ref.posts;
	
	  return _react2.default.createElement(
	    PostCollectionWrapper,
	    null,
	    _react2.default.createElement(_gatsbyImage2.default, {
	      sizes: backgroundImage.sizes,
	      style: {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%'
	      }
	    }),
	    _react2.default.createElement(
	      PostCollectionContainer,
	      null,
	      _react2.default.createElement(
	        _H2.default,
	        null,
	        'Recipes from our Collection'
	      ),
	      _react2.default.createElement(
	        PostCollectionInfo,
	        null,
	        'From our table to yours, these are our favorites.'
	      ),
	      _react2.default.createElement(
	        PostBlurbContainer,
	        null,
	        posts.map(function (post) {
	          return _react2.default.createElement(
	            PostBlurb,
	            { key: post.node.id, href: post.node.fields.slug },
	            _react2.default.createElement(PostImage, {
	              src: post.node.frontmatter.image,
	              alt: post.node.frontmatter.alt
	            }),
	            _react2.default.createElement(
	              PostTextSection,
	              null,
	              _react2.default.createElement(
	                PostHeading,
	                null,
	                post.node.frontmatter.title
	              ),
	              _react2.default.createElement(_PostTagDateRow2.default, {
	                textOne: post.node.frontmatter.tag,
	                textTwo: post.node.frontmatter.date
	              }),
	              _react2.default.createElement(
	                'p',
	                null,
	                post.node.excerpt,
	                '\u2026'
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = PostCollection;
	module.exports = exports['default'];

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin: 0 3rem;\n  padding: 0 4rem;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n\n  ', ';\n'], ['\n  position: relative;\n  margin: 0 3rem;\n  padding: 0 4rem;\n  min-height: 400px;\n  display: flex;\n  align-items: center;\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin: 0 10px;\n    padding: 0 2.5rem;\n  '], ['\n    margin: 0 10px;\n    padding: 0 2.5rem;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    outline-offset: -3px;\n\n    button {\n      outline-offset: -3px;\n    }\n  }\n\n  @media (max-width: 880px) {\n    flex-direction: column-reverse;\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    outline-offset: -3px;\n\n    button {\n      outline-offset: -3px;\n    }\n  }\n\n  @media (max-width: 880px) {\n    flex-direction: column-reverse;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 50%;\n\n  ', ';\n\n  ', ';\n'], ['\n  width: 50%;\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    width: 80%;\n  '], ['\n    width: 80%;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  width: 50%;\n  margin-left: 2rem;\n\n  ', ';\n\n  ', ';\n'], ['\n  width: 50%;\n  margin-left: 2rem;\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    margin-left: 0;\n    width: 80%;\n  '], ['\n    margin-left: 0;\n    width: 80%;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background-color: transparent;\n  top: 50%;\n  transform: translateY(-50%);\n'], ['\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background-color: transparent;\n  top: 50%;\n  transform: translateY(-50%);\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  left: 0;\n\n  svg {\n    cursor: pointer;\n  }\n'], ['\n  left: 0;\n\n  svg {\n    cursor: pointer;\n  }\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  right: 0;\n\n  svg {\n    cursor: pointer;\n  }\n'], ['\n  position: absolute;\n  right: 0;\n\n  svg {\n    cursor: pointer;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(9);
	
	var _reactSwipe = __webpack_require__(1027);
	
	var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	var _SubHeading = __webpack_require__(72);
	
	var _SubHeading2 = _interopRequireDefault(_SubHeading);
	
	var _Button = __webpack_require__(90);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gatsbyLink = __webpack_require__(68);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _FancyTextCollectionOneLine = __webpack_require__(172);
	
	var _FancyTextCollectionOneLine2 = _interopRequireDefault(_FancyTextCollectionOneLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SwipeWrapper = _styledComponents2.default.div(_templateObject, _theme.media.forSmallOnly(_templateObject2));
	
	var TextImageRowWrapper = _styledComponents2.default.div(_templateObject3);
	
	var TextContainer = _styledComponents2.default.div(_templateObject4, _theme.media.forSmallMediumOnly(_templateObject5), _theme.media.forSmallOnly(_templateObject6));
	
	var ImageContainer = _styledComponents2.default.div(_templateObject7, _theme.media.forSmallMediumOnly(_templateObject8), _theme.media.forSmallOnly(_templateObject6));
	
	var SwipeNavButton = _styledComponents2.default.button(_templateObject9);
	
	var PrevButton = SwipeNavButton.extend(_templateObject10);
	
	var NextButton = SwipeNavButton.extend(_templateObject11);
	
	var ProductCarousel = function (_Component) {
	  _inherits(ProductCarousel, _Component);
	
	  function ProductCarousel(props) {
	    _classCallCheck(this, ProductCarousel);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.goToNext = _this.goToNext.bind(_this);
	    _this.goToPrevious = _this.goToPrevious.bind(_this);
	    return _this;
	  }
	
	  ProductCarousel.prototype.goToNext = function goToNext() {
	    this.reactSwipe.next();
	  };
	
	  ProductCarousel.prototype.goToPrevious = function goToPrevious() {
	    this.reactSwipe.prev();
	  };
	
	  ProductCarousel.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      SwipeWrapper,
	      null,
	      _react2.default.createElement(
	        PrevButton,
	        { onClick: this.goToPrevious },
	        _react2.default.createElement(
	          'svg',
	          {
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: '30',
	            height: '30',
	            viewBox: '0 0 30 30',
	            transform: 'rotate(180)'
	          },
	          _react2.default.createElement(
	            'g',
	            { fill: '#000', fillRule: 'nonzero' },
	            _react2.default.createElement('path', { d: 'M15 .6A14.403 14.403 0 0 1 29.4 15 14.403 14.403 0 0 1 15 29.4 14.403 14.403 0 0 1 .6 15 14.412 14.412 0 0 1 15 .6zm0-.6a15 15 0 1 0 0 30 15 15 0 0 0 0-30z' }),
	            _react2.default.createElement('path', { d: 'M13.636 20.339l-.416-.429L17.986 15l-4.766-4.91.416-.429L18.814 15z' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactSwipe2.default
	        // swipeOptions={{
	        //   continuous: false
	        // }}
	        ,
	        { ref: function ref(reactSwipe) {
	            return _this2.reactSwipe = reactSwipe;
	          }
	        },
	        this.props.products.map(function (product, index) {
	          return _react2.default.createElement(
	            TextImageRowWrapper,
	            { key: product.node.id },
	            _react2.default.createElement(
	              TextContainer,
	              null,
	              _react2.default.createElement(
	                _SubHeading2.default,
	                { leftAlign: true },
	                product.node.tagline
	              ),
	              _react2.default.createElement(_FancyTextCollectionOneLine2.default, { titleFont: product.node.id }),
	              _react2.default.createElement(
	                'p',
	                null,
	                product.node.productDescription
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: product.node.fields.slug,
	                  'aria-label': 'See more details about ' + product.node.id
	                },
	                _react2.default.createElement(
	                  _Button2.default,
	                  null,
	                  'Learn more'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              ImageContainer,
	              null,
	              _react2.default.createElement('img', { src: product.node.image, alt: product.node.id })
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        NextButton,
	        { onClick: this.goToNext },
	        _react2.default.createElement(
	          'svg',
	          {
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: '30',
	            height: '30',
	            viewBox: '0 0 30 30'
	          },
	          _react2.default.createElement(
	            'g',
	            { fill: '#000', fillRule: 'nonzero' },
	            _react2.default.createElement('path', { d: 'M15 .6A14.403 14.403 0 0 1 29.4 15 14.403 14.403 0 0 1 15 29.4 14.403 14.403 0 0 1 .6 15 14.412 14.412 0 0 1 15 .6zm0-.6a15 15 0 1 0 0 30 15 15 0 0 0 0-30z' }),
	            _react2.default.createElement('path', { d: 'M13.636 20.339l-.416-.429L17.986 15l-4.766-4.91.416-.429L18.814 15z' })
	          )
	        )
	      )
	    );
	  };
	
	  return ProductCarousel;
	}(_react.Component);
	
	exports.default = ProductCarousel;
	module.exports = exports['default'];

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4rem 0;\n\n  // prettier-ignore\n  ', '\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4rem 0;\n\n  // prettier-ignore\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 0;\n  '], ['\n    padding: 0;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  border: solid 1px rgba(151, 151, 151, 0.23);\n  padding: 3rem;\n\n  // prettier-ignore\n  ', '\n'], ['\n  text-align: center;\n  border: solid 1px rgba(151, 151, 151, 0.23);\n  padding: 3rem;\n\n  // prettier-ignore\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    border: none;\n  '], ['\n    border: none;\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(35);
	
	var _theme = __webpack_require__(9);
	
	var _SubHeading = __webpack_require__(72);
	
	var _SubHeading2 = _interopRequireDefault(_SubHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TidyInfoBoxWrapper = _Container.Container.extend(_templateObject, _theme.media.forSmallOnly(_templateObject2));
	
	var TidyInfoBoxContainer = _Container.Container.extend(_templateObject3, _theme.media.forSmallOnly(_templateObject4));
	
	var TidyInfoBox = function TidyInfoBox() {
	  return _react2.default.createElement(
	    TidyInfoBoxWrapper,
	    null,
	    _react2.default.createElement(
	      TidyInfoBoxContainer,
	      null,
	      _react2.default.createElement(
	        _SubHeading2.default,
	        null,
	        'Pride of the Meadows'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { style: { fontSize: '40px' } },
	        'About Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, ex ea commodo consequat.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u2029Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium natus error sit. Visit Woods Produce'
	      )
	    )
	  );
	};
	
	exports.default = TidyInfoBox;
	module.exports = exports['default'];

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n'], ['\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  background-image: linear-gradient(\n    to bottom,\n    #102219,\n    #10231a,\n    #0f251b,\n    #0f261c,\n    #0e281d\n  );\n  opacity: 0.4;\n  z-index: 10;\n'], ['\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  background-image: linear-gradient(\n    to bottom,\n    #102219,\n    #10231a,\n    #0f251b,\n    #0f261c,\n    #0e281d\n  );\n  opacity: 0.4;\n  z-index: 10;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  color: white;\n  width: 100%;\n  font-size: 65px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 20;\n  text-align: center;\n\n  ', ';\n\n  ', ';\n'], ['\n  position: absolute;\n  color: white;\n  width: 100%;\n  font-size: 65px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 20;\n  text-align: center;\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-size: 52px;\n  '], ['\n    font-size: 52px;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    font-size: 40px;\n  '], ['\n    font-size: 40px;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  height: 625px;\n  overflow: hidden;\n  position: relative;\n\n  @media (max-width: 1345px) {\n    height: 625px;\n  }\n  @media (max-width: 1125px) {\n    height: 525px;\n  }\n  @media (max-width: 950px) {\n    height: 425px;\n  }\n  @media (max-width: 780px) {\n    height: 425px;\n  }\n'], ['\n  height: 625px;\n  overflow: hidden;\n  position: relative;\n\n  @media (max-width: 1345px) {\n    height: 625px;\n  }\n  @media (max-width: 1125px) {\n    height: 525px;\n  }\n  @media (max-width: 950px) {\n    height: 425px;\n  }\n  @media (max-width: 780px) {\n    height: 425px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: none;\n\n  // prettier-ignore\n  ', '\n\n  // prettier-ignore\n  ', '\n\n  img {\n    object-fit: contain;\n    font-family: \'object-fit: contain;\';\n    margin: 0;\n  }\n'], ['\n  display: none;\n\n  // prettier-ignore\n  ', '\n\n  // prettier-ignore\n  ', '\n\n  img {\n    object-fit: contain;\n    font-family: \'object-fit: contain;\';\n    margin: 0;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    display: block;\n    position: absolute;\n    right: 10%;\n    width: 20%;\n    bottom: -20px;\n    z-index: 10;\n  '], ['\n    display: block;\n    position: absolute;\n    right: 10%;\n    width: 20%;\n    bottom: -20px;\n    z-index: 10;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    width: 150px;\n    right: 5%;\n  '], ['\n    width: 150px;\n    right: 5%;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding-bottom: 56.25%; /* 16:9 */\n\n  @media (max-width: 780px) {\n    display: none;\n  }\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding-bottom: 56.25%; /* 16:9 */\n\n  @media (max-width: 780px) {\n    display: none;\n  }\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(86);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _theme = __webpack_require__(9);
	
	var _POTMBubbleUSA = __webpack_require__(397);
	
	var _POTMBubbleUSA2 = _interopRequireDefault(_POTMBubbleUSA);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ComponentWrapper = _styledComponents2.default.section(_templateObject);
	
	var Overlay = _styledComponents2.default.div(_templateObject2);
	
	var OverlayText = _styledComponents2.default.h1(_templateObject3, _theme.media.forSmallMediumOnly(_templateObject4), _theme.media.forSmallOnly(_templateObject5));
	
	var VideoHeroWrapper = _styledComponents2.default.div(_templateObject6);
	
	var BadgeImage = _styledComponents2.default.div(_templateObject7, _theme.media.forSmallMediumOnly(_templateObject8), _theme.media.forSmallOnly(_templateObject9));
	
	var VideoContainer = _styledComponents2.default.div(_templateObject10);
	
	var VideoHero = function (_React$Component) {
	  _inherits(VideoHero, _React$Component);
	
	  function VideoHero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VideoHero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      showVideo: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  VideoHero.prototype.onVideoStart = function onVideoStart() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ showVideo: true });
	    }, 100);
	  };
	
	  VideoHero.prototype.render = function render() {
	    var _props = this.props,
	        mobileHeroImage = _props.mobileHeroImage,
	        desktopHeroImage = _props.desktopHeroImage;
	
	
	    return _react2.default.createElement(
	      ComponentWrapper,
	      null,
	      _react2.default.createElement(
	        OverlayText,
	        null,
	        'Local tastes better.'
	      ),
	      _react2.default.createElement(Overlay, null),
	      _react2.default.createElement(
	        VideoHeroWrapper,
	        null,
	        typeof window !== 'undefined' && window.matchMedia('(min-width: 680px)').matches ? _react2.default.createElement(
	          VideoContainer,
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: desktopHeroImage.sizes,
	            style: {
	              position: 'absolute',
	              left: 0,
	              top: 0,
	              width: '100%',
	              height: '100%'
	            }
	          })
	        ) : _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: mobileHeroImage.sizes,
	          style: {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: '100%',
	            height: '100%'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        BadgeImage,
	        null,
	        _react2.default.createElement('img', { src: _POTMBubbleUSA2.default, alt: 'Fresh from the Vine and Hand Picked Badge' })
	      )
	    );
	  };
	
	  return VideoHero;
	}(_react2.default.Component);
	
	exports.default = VideoHero;
	module.exports = exports['default'];

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/POTM-Bubble-USA.58b4da02.svg";

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoHero = __webpack_require__(415);
	
	var _VideoHero2 = _interopRequireDefault(_VideoHero);
	
	var _IconBlurbRow = __webpack_require__(409);
	
	var _IconBlurbRow2 = _interopRequireDefault(_IconBlurbRow);
	
	var _TidyInfoBox = __webpack_require__(414);
	
	var _TidyInfoBox2 = _interopRequireDefault(_TidyInfoBox);
	
	var _ImageBorderInfoBox = __webpack_require__(170);
	
	var _ImageBorderInfoBox2 = _interopRequireDefault(_ImageBorderInfoBox);
	
	var _ProductCarousel = __webpack_require__(412);
	
	var _ProductCarousel2 = _interopRequireDefault(_ProductCarousel);
	
	var _PostCollection = __webpack_require__(411);
	
	var _PostCollection2 = _interopRequireDefault(_PostCollection);
	
	var _BottomSection = __webpack_require__(127);
	
	var _BottomSection2 = _interopRequireDefault(_BottomSection);
	
	var _SubHeading = __webpack_require__(72);
	
	var _SubHeading2 = _interopRequireDefault(_SubHeading);
	
	var _gatsbyLink = __webpack_require__(68);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_VideoHero2.default, {
	      mobileHeroImage: data.mobileHero,
	      desktopHeroImage: data.desktopHeroImage
	    }),
	    _react2.default.createElement(_IconBlurbRow2.default, { blurbs: data.pageContentYaml.about_us_icon_blurb_row }),
	    _react2.default.createElement(
	      _ImageBorderInfoBox2.default,
	      { borderImage: data.infoBoxBorder },
	      _react2.default.createElement(
	        _SubHeading2.default,
	        null,
	        'Pride of the Meadows'
	      ),
	      _react2.default.createElement(
	        'h2',
	        { style: { fontSize: '40px' } },
	        'About Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We work with farmers local to your area to source the freshest product possible, package it in our food safe facility, and send it to grocers near you. All of our products are delivered from farm to store within 72 hours and packed by hand to ensure the best quality possible.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can find Pride of the Meadows branded fruits and vegetables in Virginia and North Carolina at participating Food Lions. If we\'re not in your area yet please ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact-us', style: { color: '#338a1a' } },
	          'contact us'
	        ),
	        ' ',
	        'and we\'ll see what we can do.'
	      )
	    ),
	    _react2.default.createElement(_ProductCarousel2.default, { products: data.products.edges }),
	    _react2.default.createElement(_PostCollection2.default, {
	      backgroundImage: data.recipeBackground,
	      posts: data.recipes.edges
	    }),
	    _react2.default.createElement(_BottomSection2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: Sacramento;\n  color: ', ';\n  font-size: ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  font-family: Sacramento;\n  color: ', ';\n  font-size: ', ';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 50px;\n    width: 100%;\n  '], ['\n    font-size: 50px;\n    width: 100%;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    font-size: 42px;\n  '], ['\n    font-size: 42px;\n  ']);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FancyFont = _styledComponents2.default.span(_templateObject, function (props) {
	  return props.theme.potmGreen;
	}, function (props) {
	  return props.fontSize || '58px';
	}, _theme.media.forSmallMediumOnly(_templateObject2), _theme.media.forSmallOnly(_templateObject3));
	
	exports.default = FancyFont;
	module.exports = exports['default'];

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: \'Montserrat\';\n  font-size: 40px;\n  margin-left: 10px;\n  color: ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  font-family: \'Montserrat\';\n  font-size: 40px;\n  margin-left: 10px;\n  color: ', ';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 36px;\n  '], ['\n    font-size: 36px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    font-size: 30px;\n  '], ['\n    font-size: 30px;\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(9);
	
	var _FancyFont = __webpack_require__(71);
	
	var _FancyFont2 = _interopRequireDefault(_FancyFont);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FancyTitle = _styledComponents2.default.span(_templateObject, function (props) {
	  return props.theme.defaultHeaderColor;
	}, _theme.media.forSmallMediumOnly(_templateObject2), _theme.media.forSmallOnly(_templateObject3));
	
	var FancyTextCollectionOneLine = function FancyTextCollectionOneLine(_ref) {
	  var titleFont = _ref.titleFont;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _FancyFont2.default,
	      null,
	      'Just'
	    ),
	    _react2.default.createElement(
	      FancyTitle,
	      null,
	      titleFont
	    )
	  );
	};
	
	exports.default = FancyTextCollectionOneLine;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: 0.75rem;\n  font-family: Montserrat;\n  font-size: 0.9rem;\n\n  span:first-child {\n    text-transform: uppercase;\n    font-weight: bold;\n  }\n\n  span:last-child {\n    color: #9b9b9b;\n  }\n'], ['\n  margin-bottom: 0.75rem;\n  font-family: Montserrat;\n  font-size: 0.9rem;\n\n  span:first-child {\n    text-transform: uppercase;\n    font-weight: bold;\n  }\n\n  span:last-child {\n    color: #9b9b9b;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PostTagDateRowContainer = _styledComponents2.default.div(_templateObject);
	
	var PostTagDateRow = function PostTagDateRow(_ref) {
	  var textOne = _ref.textOne,
	      textTwo = _ref.textTwo;
	  return _react2.default.createElement(
	    PostTagDateRowContainer,
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      textOne,
	      ' '
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '/ ',
	      textTwo
	    )
	  );
	};
	
	exports.default = PostTagDateRow;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-80d6fc98526f463ef52c.js